import { StylesConfig } from 'react-select/dist/declarations/src/styles';
import { GroupBase, Theme } from 'react-select';
import theme from '@/styles/theme';
import { SelectOptionType } from '@/components/form/MultiSelect/MultiSelect';

export const themeOverride = (selectTheme: Theme) => ({
  ...selectTheme,
  colors: {
    ...selectTheme.colors,
    primary25: theme.color.secondary_200, // '#CAE0EA',
  },
});

export const selectStylesOverride: StylesConfig<SelectOptionType, true, GroupBase<SelectOptionType>> = {
  container: (baseStyles, state) => ({
    ...baseStyles,
    outline: '0 !important',
    '&.is-invalid > div[class$="-control"]': {
      borderColor: theme.color.destructive_400,
    },
  }),
  control: (baseStyles, state) => ({
    ...baseStyles,
    borderWidth: 2,
    borderColor: state.isFocused ? theme.color.secondary_500 : theme.color.neutral_400,
    boxShadow: 'unset',
    minHeight: '2.5rem',
    '&:hover': {
      background: theme.color.neutral_100,
    },
    '&:focus': {
      outline: '0 !important',
      border: 0,
    },
  }),
  valueContainer: (baseStyles, state) => ({
    ...baseStyles,
    padding: '0 0.275rem',
  }),
  input: (baseStyles, state) => ({ ...baseStyles, color: theme.color.dark }),
  placeholder: (baseStyles, state) => ({
    ...baseStyles,
    color: theme.color.neutral_500,
    fontSize: '.875rem',
    paddingLeft: '2px',
  }),
  dropdownIndicator: (baseStyles, state) => ({ ...baseStyles, color: theme.color.dark }),
  multiValue: (baseStyle, state) => ({ ...baseStyle, background: theme.color.secondary_200 }),
  multiValueRemove: (baseStyle) => ({
    ...baseStyle,
    '&:hover': { background: theme.color.destructive_400, color: 'white' },
  }),
  menu: (baseStyle) => ({
    ...baseStyle,
    border: 0,
    background: 'white',
    boxShadow: theme.box_shadow.base,
    borderRadius: theme.radius.xs,
    marginTop: '0',
    overflow: 'hidden',
  }),
  menuList: (baseStyle) => ({
    ...baseStyle,
    background: theme.color.white,
  }),
  option: (baseStyle) => ({
    ...baseStyle,
    padding: '.375rem .75rem',
    fontSize: '.875rem',
    '&:hover': {
      background: theme.color.secondary_200,
    },
  }),
};
